import { render, staticRenderFns } from "./UploadAgree.vue?vue&type=template&id=4c2bee69"
import script from "./UploadAgree.vue?vue&type=script&lang=js"
export * from "./UploadAgree.vue?vue&type=script&lang=js"
import style0 from "./UploadAgree.vue?vue&type=style&index=0&id=4c2bee69&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports